// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"9f534cfe","402":"90cbeda6","435":"f9a56bba","453":"99dcf01f","572":"12224683","713":"46f88fd6"}[chunkId] + ".chunk.js";
};